const SignatureDocumentStatus = Object.freeze({
  DocNotGenerated: 1,
  InRow: 2,
  InSigningProcess: 3,
  Canceled: 4,
  Signed: 5,
  RenderedIneffective: 6,
});

export const SignatureDocumentStatusColor = Object.freeze({
  [SignatureDocumentStatus.DocNotGenerated]: 'gray',
  [SignatureDocumentStatus.InRow]: 'gray',
  [SignatureDocumentStatus.InSigningProcess]: 'light-purple',
  [SignatureDocumentStatus.Canceled]: 'dark-red',
  [SignatureDocumentStatus.Signed]: 'light-green',
});

export default SignatureDocumentStatus;
